import { CityAutocomplete } from '../autocomplete/city'
import { TagAutocomplete } from '../autocomplete/tag'
import { initCustomCheckboxes, initCustomRadios, initCustomForms } from '../common'
import { DataSender, DataLoader } from '../loaders'
import { TokenList } from '../ui/token_list'


require('jquery-ui');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/disable-selection');

/**
* Yard
*/

class Yard {
    constructor(options) {
        var that = this;
        window.yard = this;

        this.eventsPerPage=12;
        this.locked=false;
        this.scrollThrottle=null;

    // properties
        this.dateFormat = options.dateFormat;
        this.texts = options.texts;

        this.loadedDataQuery = 'all_events';
        this.loadedPage = 1;
        this.loadedStreamId = options.loadedStreamId;
        this.loadedStreamType = options.loadedStreamType;
        this.loadedStreamTotal = options.loadedStreamTotal;
        this.loadMore = this.loadedPage * this.eventsPerPage < this.loadedStreamTotal;

    // layout
        this.eventsRequestBox = $('.events-request');
        this.view = $('section.yard');
        this.sidebar = this.view.find('aside');
        this.reminder = this.sidebar.find('.reminder');
        this.menu = this.view.find('.sidebar-menu');
        this.stream = this.view.find('#stream');
        this.streamContent = this.stream.find('#content');
        this.streamLoader = this.streamContent.find('.list-loader');

    // init
        this.initEventsRequestBox();
        this.initEventReminder();
        this.initStreamsMenu();
        this.initStream();

    }

    // SCROLL:

    bindScroll() {
        $(window).bind('scroll', { reference: this }, this.scrollHandler);
    }

    unbindScroll() {
        $(window).unbind('scroll', this.scrollHandler);
    }

    scrollHandler(e) {
        var that = e.data.reference;

        window.clearTimeout(that.scrollThrottle);
        that.scrollThrottle = window.setTimeout(that.scrollHandlerCallback, 100, that);
    }

    scrollHandlerCallback(that) {
        if($(window).scrollTop() >= $(document).height() - $(window).height() - 250) {
            that.unbindScroll();
            that.loadStreamEvents();
        }
    }

// LAYOUT:

    createLoader(target, margin) {
        target.html('<div class="stream-loader' + (margin ? ' margin' : '') + '"><div class="activity-indicator gray mt-2"></div></div>');
    }

    updateSidebarHeight() {
        var bannerHeight = !this.stream.is(':first-child') ? 130 : 0;
        this.sidebar.height('auto');

        if(this.sidebar.outerHeight() < (this.stream.outerHeight() + bannerHeight)) {
            this.sidebar.height(this.stream.outerHeight() + bannerHeight);
        }
    }

    lock() {
        this.locked = true;
    }

    unlock() {
        this.locked = false;
    }

// EVENTS REQUEST:

    initEventsRequestBox() {
        var that = this;

        if(this.eventsRequestBox.length) {
            this.eventsRequestButton = this.eventsRequestBox.find('a.request');
            this.eventsRequestButton.bind('click', function() {
                if(!that.eventsRequestButton.hasClass('sent')) {
                    that.sendEventsRequest();
                }

                return false;
            });

            this.eventsRequestDismiss = this.eventsRequestBox.find('a.dismiss');
            this.eventsRequestDismiss.bind('click', function() {
                that.removeEventsRequestBox();
                that.dismissEventsRequest();
                return false;
            });
        }
    }

    toggleEventsRequestBox() {
        if(this.eventsRequestBox.length) {
            this.eventsRequestBox.slideToggle(250);
        }
    }

    removeEventsRequestBox() {
        var that = this;

        if(this.eventsRequestBox.length) {
            this.toggleEventsRequestBox();

            window.setTimeout(function() {
                that.eventsRequestBox.remove();
                that.eventsRequestBox = null;
            }, 250);
        }
    }

    sendEventsRequest() {
        var that = this;

        new DataLoader({
            url: '/events/request/',
            success: function(data) {
                if(data.success) {
                    that.eventsRequestButton.addClass('sent');
                }
            }
        });
    }

    dismissEventsRequest() {
        new DataLoader({
            url: '/events/request-dismiss/'
        });
    }

// EVENT REMINDER:

    initEventReminder() {
        var that = this;
        var button = this.reminder.find('a');

        if(this.reminder.hasClass('recommend')) {
            button.bind('click', function() {
                var today = new Date();
                var query = 'single_' + window.evedo.dateFormat;
                query = query.replace(/dd/, today.getDate());
                query = query.replace(/mm/, today.getMonth() + 1);
                query = query.replace(/yyyy/, today.getFullYear());

                that.loadStream('recommended', query);

                return false;
            });
        }
    }

// MENU:

    initStreamsMenu() {
        var that = this;

        this.menuStreams = this.menu.find('.group');
        this.menuStreams.sortable({
            axis: 'y',
            handle: '.icon',
            items: 'a',
            opacity: 0.25,
            placeholder: 'sorting-placeholder',
            scroll: false,

            stop: function(e, ui) {
                var ids = that.menuStreams.sortable('toArray', { attribute: 'data-id' });
                var order = [];

                for(var i in ids) {
                    if(ids[i]) {
                        order.push(parseInt(ids[i]));
                    }
                }

                that.saveStreamsOrder(order);
            }
        });

        this.refreshStreamMenuButtons();

        this.menuAddButton = this.menu.find('a#add');
        this.menuAddButton.bind('click', { reference: this }, this.menuAddButtonClickHandler);
    }

    refreshStreamMenuButtons() {
        this.menuStreamButtons = this.menuStreams.find('a').filter('[data-id]');
        this.menuStreamButtons.unbind('click').bind('click', { reference: this }, this.menuStreamButtonClickHandler);
    }

    insertMenuStreamButton(id, label) {
        if(this.newStreamButton) {
            this.menuStreams.sortable('enable').removeClass('disable-sorting');
            this.newStreamButton.remove();
            this.newStreamButton = null;
        }

        $('<a class="indent active" data-id="' + id + '" data-type="custom" href="#"><span class="icon"></span><span>' + label + '</span></a>').appendTo(this.menuStreams);
        this.refreshStreamMenuButtons();
    }

    menuStreamButtonClickHandler(e) {
        var that = e.data.reference;
        var button = $(e.currentTarget);

        if(!button.hasClass('active')) {
            that.loadStream(button.data('id'));
        }

        return false;
    }

    menuAddButtonClickHandler(e) {
        var that = e.data.reference;

        that.addStream();

        return false;
    }

    saveStreamsOrder(order) {
        new DataSender({
            data: { order: order },
            url: '/yard/reorder/'
        });
    }

// STREAMS:

    loadStream(streamId, query) {
        var that = this;

        if(this.locked) return;
        this.lock();

        // parse id
        if(typeof streamId == 'string') {
            if(streamId == 'current') {
                streamId = this.loadedStreamId;
            }
            else if(streamId == 'first') {
                streamId = this.menuStreamButtons.filter(':first-child').data('id');
            }
            else if(streamId == 'last') {
                streamId = this.menuStreamButtons.filter(':last-child').data('id');
            }
            else {
                streamId = this.menuStreamButtons.filter('[data-type="' + streamId + '"]').eq(0).data('id');
            }
        }

        if(this.menuStreamButtons.filter('[data-id="' + streamId + '"]').length) {
            if(this.newStreamButton) {
                this.menuStreams.sortable('enable').removeClass('disable-sorting');
                this.newStreamButton.remove();
                this.newStreamButton = null;
            }

            if(this.restoreButtonLabel) {
                this.restoreButtonLabel.button.text(this.restoreButtonLabel.label);
                this.restoreButtonLabel = null;
            }

            this.menuStreamButtons.removeClass('active');
            this.menuStreamButtons.filter('[data-id="' + streamId + '"]').addClass('active');

            $('html, body').scrollTop(0);
            this.createLoader(this.stream);

            new DataSender({
                data: (!query) ? { mode: 'init' } : { mode: 'init', query: query },
                url: '/yard/load/' + streamId + '/',

                success: function(data) {
                    that.loadedDataQuery = (!query) ? 'all_events' : query;
                    that.loadedPage = 1;
                    that.loadedStreamId = streamId;
                    that.loadedStreamTotal = data.total;
                    that.loadedStreamType = that.menuStreamButtons.filter('.active').data('type');
                    that.loadMore = that.loadedPage * that.eventsPerPage < that.loadedStreamTotal;

                    that.stream.html(data.stream);
                    that.streamContent = that.stream.find('#content');
                    that.streamLoader = that.streamContent.find('.list-loader');

                    that.initStream();
                    that.unlock();
                },

                error: function() {
                    that.loadedStreamId = null;
                    that.unlock();
                }
            });
        }
        else {
            this.unlock();
        }
    }

    initStream() {
        var that = this;

        // stream header
        this.streamHeader = this.stream.find('header');
        this.streamH1 = this.streamHeader.find('h1');
        this.streamH2 = this.streamHeader.find('h2');
        this.streamH1.data('default', this.streamH1.text());
        this.streamH2.data('default', this.streamH2.text());

        // stream options
        this.streamOptionButtons = this.streamHeader.find('.buttons').find('a');
        this.streamOptionButtons.bind('click', function() {
            var button = $(this);

            if(button.hasClass('filter') || button.hasClass('edit')) {
                if(!button.hasClass('active')) {
                    that.closeStreamForms();
                    (button.hasClass('filter')) ? that.openStreamFilterForm() : that.openStreamEditForm();
                }
                else {
                    that.closeStreamForms();
                }

                that.updateSidebarHeight();
            }

            else if(button.hasClass('remove')) {
                that.removeStream();
            }

            return false;
        });

        // stream forms
        this.streamForms = this.stream.find('form');
        this.streamFilterForm = null;
        this.streamEditForm = null;

        if(this.streamForms.filter('.filter.shown').length) {
            this.unlock();
            this.openStreamFilterForm();
        }

        // stream loader
        this.unbindScroll();

        if(this.loadMore) {
            this.streamLoader.find('a.btn').bind('click', function() {
                that.loadStreamEvents();
                return false;
            });

            this.bindScroll();
        }
        else {
            this.streamLoader.addClass('hidden');
        }

        // sidebar
        this.updateSidebarHeight();
    }

    openStreamFilterForm() {
        var that = this;

        if(this.locked) return;
        this.lock();

        if(!this.loadedStreamId) return;

        // form
        if(!this.streamFilterForm) {
            this.streamFilterForm = this.stream.find('form.filter');

            if(!this.streamFilterForm.length) {
                this.streamFilterForm = null;
                return;
            }

            // toggle
            initCustomForms(this.streamFilterForm);

            this.streamFilterFormMode = 'single';
            this.streamFilterForm.find('input[name="mode"]').bind('change', function(e) {
                if($(e.currentTarget).val() == 'range') {
                    that.streamFilterFormMode = 'range';
                    that.streamFilterFormStart.parent().addClass('range');
                    that.streamFilterFormStart.prop('placeholder', that.texts.startDate).data('placeholder', that.texts.startDate);
                }
                else {
                    that.streamFilterFormMode = 'single';
                    that.streamFilterFormStart.parent().removeClass('range');
                    that.streamFilterFormStart.prop('placeholder', that.texts.selectADay).data('placeholder', that.texts.selectADay);
                }
            });

            // datepickers
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);

            this.streamFilterFormStart = this.streamFilterForm.find('input.start-date');
            this.streamFilterFormEnd = this.streamFilterForm.find('input.end-date');

            this.streamFilterForm.find('.inputs').find('input')
            .datepicker({
                format: window.evedo.dateFormat,
                weekStart: 1,

                onRender: function(date) {
                    return date.valueOf() < today.valueOf() ? 'disabled' : '';
                },

                leftPosition: function() {
                    return Math.round($(window).width() - 980) / 2 + 500;
                }
            })

            .on('show', function(e) {
                $(e.currentTarget).prop('placeholder', '');
                window.evedo.disablePageScrolling();
            })

            .on('hide', function(e) {
                $(e.currentTarget).prop('placeholder', $(e.currentTarget).data('placeholder'));
                window.evedo.enablePageScrolling();
            });

            // submit
            this.streamFilterForm.bind('submit', function() {
                that.submitStreamFilterForm();
                return false;
            });

            // reset
            this.streamFilterFormReset = this.streamFilterForm.find('button[type="reset"]');
            this.streamFilterFormReset.bind('click', function() {
                that.resetStreamFilterForm();
                return false;
            });
        }

        this.streamFilterForm.addClass('shown');

        // headings
        this.streamH1.text(this.texts.streamFilterH1);
        this.streamH2.text(this.texts.streamFilterH2);

        // buttons
        this.streamOptionButtons.removeClass('active').filter('.filter').addClass('active');

        this.unlock();
    }

    submitStreamFilterForm() {
        if(!this.loadedStreamId) return;

        var start = this.streamFilterFormStart.val();
        var end = this.streamFilterFormEnd.val();

        if((this.streamFilterFormMode == 'single' && !start.length) || (this.streamFilterFormMode == 'range' && !start.length && !end.length)) {
            query = 'all_events';
        }
        else {
            if(this.streamFilterFormMode == 'single') {
                query = 'single_' + start;
            }
            else {
                query = 'range_' + start + '_' + end;
            }
        }

        if(query != this.loadedDataQuery) {
            this.streamFilterForm.addClass('filtered');
            this.streamFilterFormStart.datepicker('hide');
            this.streamFilterFormEnd.datepicker('hide');

            if(query == 'all_events') {
                this.resetStreamFilterForm();
            }
            else {
                this.loadStreamEvents(query);
            }
        }
    }

    resetStreamFilterForm(dontRefresh) {
        if(!this.loadedStreamId) return;

        this.streamFilterForm.removeClass('filtered');
        this.streamFilterFormStart.val('');
        this.streamFilterFormEnd.val('');

        if(!dontRefresh) {
            this.loadStreamEvents('all_events');
        }
    }

    openStreamEditForm() {
        var that = this;

        if(this.locked) return;
        this.lock();

        if(!this.loadedStreamId) return;

        // form
        if(!this.streamEditForm) {
            this.streamEditForm = this.stream.find('form.edit');

            if(!this.streamEditForm.length) {
                this.streamFilterForm = null;
                return;
            }
        }

        this.streamEditForm.addClass('shown').html('<div class="loading-form"><div class="activity-indicator gray"></div></div>');

        new DataLoader({
            url: '/yard/edit/' + this.loadedStreamId + '/',

            success: function(data) {
                that.streamEditForm.html(data.formContent);
                that.initStreamEditForm();

                that.unlock();
                that.updateSidebarHeight();
            },

            error: function() {
                that.closeStreamForms();
                that.unlock();
                that.updateSidebarHeight();
            }
        });

        // headings
        this.streamH1.text(this.texts.streamEditH1);
        this.streamH2.text(this.texts.streamEditH2);

        // buttons
        this.streamOptionButtons.removeClass('active').filter('.edit').addClass('active');

        this.unlock();
    }

    initStreamEditForm(focusName) {
        var that = this;

        if(this.loadedStreamId) {
            var button = this.menuStreamButtons.filter('[data-id="' + this.loadedStreamId + '"]').find('span:eq(1)');
            this.restoreButtonLabel = {
                button: button,
                label: button.text()
            };
        }
        else {
            var button = this.newStreamButton.find('span:eq(1)');
        }

        var nameInput = this.streamEditForm.find('input[name="name"]');
        var citiesList = this.streamEditForm.find('.cities').find('.token-list');
        var citiesInput = this.streamEditForm.find('input[name="search-cities"]');
        var citiesCurrentLocation = this.streamEditForm.find('input[name="current-location"]');
        var keywordsList = this.streamEditForm.find('.keywords').find('.token-list');
        var keywordsInput = this.streamEditForm.find('input[name="search-keywords"]');

        // name
        nameInput.data('default-value', nameInput.val());
        nameInput.bind('input', function() {
            button.text(nameInput.val());
        });

        if(!this.loadedStreamId) {
            nameInput.focus();
        }

        // categories
        initCustomCheckboxes(this.streamEditForm);

        // cities
        new CityAutocomplete(
            citiesInput, {
                clear: true,
                callback: function(data) {
                    citiesList.add({
                        label: data.name,
                        sublabel: '(' + data.country_code + ')',
                        value: data.id,
                        remove: true
                    });
                }
            }
        );

        citiesList = new TokenList(citiesList, 'cities-ids', {
            limit: 10,
            changed: function(result) {
                if(result.limitReached) {
                    citiesInput.prop('disabled', true);
                }
                else {
                    citiesInput.prop('disabled', false);
                }

                if(that.equalizeHeights) {
                    that.equalizeHeights();
                }
            }
        });

        initCustomForms(this.streamEditForm);
        this.streamEditForm.find('a[rel="tooltip"]').tooltip({ animation: false });

        // keywords
        new TagAutocomplete(
            keywordsInput, {
                clear: true,
                callback: function(data) {
                    keywordsList.add({
                        label: data.label,
                        value: data.id,
                        remove: true
                    });
                }
            }
        );

        keywordsList = new TokenList(keywordsList, 'tags-ids', {
            limit: 20,
            changed: function(result) {
                if(result.limitReached) {
                    keywordsInput.prop('disabled', true);
                }
                else {
                    keywordsInput.prop('disabled', false);
                }

                if(that.equalizeHeights) {
                    that.equalizeHeights();
                }
            }
        });

        // equal height
        this.equalizeHeights = function() {
            if(citiesList.target && keywordsList.target) {
                var height = Math.max(
                    citiesList.target.height('auto').height(),
                    keywordsList.target.height('auto').height()
                );

                if(citiesList.getIntArray().length || keywordsList.getIntArray().length) {
                    citiesList.target.addClass('padding-bottom');
                    keywordsList.target.addClass('padding-bottom');
                }
                else {
                    citiesList.target.removeClass('padding-bottom');
                    keywordsList.target.removeClass('padding-bottom');
                }

                citiesList.target.height(height);
                keywordsList.target.height(height);

                that.updateSidebarHeight();
            }
        };

        this.equalizeHeights();

        // submit
        this.streamEditForm.find('.actions').find('.btn:first-child').bind('click', function() {
            var selectedCategories = [];
            that.streamEditForm.find('input[name="categories[]"]').each(function() {
                if($(this).is(':checked')) {
                    selectedCategories.push(parseInt($(this).val()));
                }
            });

            nameInput.val($.trim(nameInput.val()));

            if(!nameInput.val().length) {
                nameInput.highlight('red', { hideEvent: 'input', offset: [-250, 0], placement: 'top', text: that.texts.streamEmptyNameError });
                nameInput.focus();
            }
            else if(!selectedCategories.length && !citiesList.getIntArray().length && !keywordsList.getIntArray().length && !citiesCurrentLocation.is(':checked')) {
                that.streamEditForm.highlight('red', { hideEvent: 'click', offset: [-2, 45], text: that.texts.streamNoDataError });
            }
            else {
                that.submitStreamEditForm({
                    name: nameInput.val(),
                    categories: selectedCategories,
                    cities: citiesList.getIntArray(),
                    tags: keywordsList.getIntArray(),
                    current_location: citiesCurrentLocation.is(':checked') ? 1 : 0
                });
            }

            return false;
        });

        // cancel
        this.streamEditForm.find('.actions').find('.btn:last-child').bind('click', function() {
            if(that.loadedStreamId) {
                that.closeStreamForms();
            }
            else {
                that.loadStream('first');
            }
            return false;
        });
    }

    submitStreamEditForm(streamData) {
        var that = this;

        if(this.locked) return;
        this.lock();

        var mode = (!this.loadedStreamId) ? 'add' : 'edit';

        if(mode == 'edit') {
            streamData.id = that.loadedStreamId;
        }

        new DataSender({
            data: streamData,
            url: '/yard/save/',

            success: function(data) {
                that.unlock();

                if(data.success) {
                    if(mode == 'add') {
                        that.stream.find('header').find('a').removeClass('error');
                        that.stream.find('form.edit').find('.error-message').removeClass('shown');

                        that.insertMenuStreamButton(data.id, data.name);
                        that.loadStream('last');
                    }
                    else {
                        that.streamOptionButtons.filter('.edit').removeClass('error');
                        that.streamEditForm.find('.error-message').removeClass('shown');

                        that.restoreButtonLabel.label = data.name;
                        that.streamH1.data('default', data.name);

                        if(that.streamFilterForm) {
                            that.resetStreamFilterForm(true);
                        }

                        that.streamH1.text(that.streamH1.data('default'));
                        that.streamH2.text(that.streamH2.data('default'));
                        that.streamEditForm.html('<div class="saved"><span class="message">' + that.texts.saved + '</span></div>');

                        that.loadStreamEvents('all_events', function() {
                            window.setTimeout(function() {
                                that.closeStreamForms();
                                that.updateSidebarHeight();
                            }, 1000);
                        });
                    }
                }
                else {
                    if(mode == 'add') {
                        that.stream.find('header').find('a').addClass('error');
                        that.stream.find('form.edit').find('.error-message').addClass('shown').text(data.error);
                    }
                    else {
                        that.streamOptionButtons.filter('.edit').addClass('error');
                        that.streamEditForm.find('.error-message').addClass('shown').text(data.error);
                    }
                }
            },

            error: function() {
                that.unlock();
            }
        });
    }

    closeStreamForms() {
        this.streamH1.text(this.streamH1.data('default'));
        this.streamH2.text(this.streamH2.data('default'));

        this.streamOptionButtons.removeClass('active error');
        this.streamForms.removeClass('shown');

        if(this.restoreButtonLabel) {
            this.restoreButtonLabel.button.text(this.restoreButtonLabel.label);
            this.restoreButtonLabel = null;
        }
    }

    loadStreamEvents(query, callback) {
        var that = this;

        if(this.locked) return;
        this.lock();

        if(!this.loadedStreamId) return;

        this.streamLoader.find('a.btn').html('<div class="activity-indicator pt-2"></div>');

        let loadParameters = {};

        if(!query) {
            loadParameters = {
                mode: 'load',
                query: this.loadedDataQuery
            };
        }
        else {
            this.loadedDataQuery = query;
            this.createLoader(this.streamContent, true);

            loadParameters = {
                mode: 'refresh',
                query: this.loadedDataQuery
            };
        }

        new DataSender({
            data: loadParameters,
            url: '/yard/load/' + this.loadedStreamId + '/',

            success: function(data) {
                if(loadParameters.mode == 'load') {
                    that.loadedPage++;
                    that.loadMore = that.loadedPage * that.eventsPerPage < that.loadedStreamTotal;

                    that.streamContent.find('.events-list-new.row').append(`<div class="page col-12 text-center"><span>${that.texts.page} ${that.loadedPage}</span></div>${data.events}`);
                }
                else {
                    that.loadedPage = 1;
                    that.loadedStreamTotal = data.total;
                    that.loadMore = that.loadedPage * that.eventsPerPage < that.loadedStreamTotal;

                    that.streamContent.html(data.streamContent);
                    that.streamLoader = that.streamContent.find('.list-loader');

                    if(that.streamLoader.length) {
                        that.streamLoader.find('a.btn').bind('click', function() {
                            that.loadStreamEvents();
                            return false;
                        });
                    }

                    that.unbindScroll();
                }

                if(that.loadMore) {
                    that.streamLoader.find('a.btn').text(that.streamLoader.find('a.btn').data('text'));

                    if(that.loadedPage < 3) {
                        that.bindScroll();
                    }
                }
                else {
                    that.streamLoader.addClass('hidden');
                }

                that.unlock();
                that.updateSidebarHeight();

                if(callback) {
                    callback();
                }
            },

            error: function() {
                that.unlock();
            }
        });
    }

    addStream() {
        var that = this;

        if(this.locked) return;

        if(!this.newStreamButton) {
            this.lock();

            this.menuStreams.sortable('disable').addClass('disable-sorting');
            this.menuStreamButtons.removeClass('active');

            if(this.restoreButtonLabel) {
                this.restoreButtonLabel.button.text(this.restoreButtonLabel.label);
                this.restoreButtonLabel = null;
            }

            this.newStreamButton = $('<a class="indent active" href="#"><span class="icon"></span><span>' + this.texts.newCustomStream + '</span></a>').appendTo(this.menuStreams);
            this.newStreamButton.bind('click', function() {
                return false;
            });

            $('html, body').scrollTop(0);
            this.createLoader(this.stream);

            new DataLoader({
                url: '/yard/add/',

                success: function(data) {
                    that.loadedStreamId = null;

                    that.stream.html(data.streamContent);
                    that.streamEditForm = that.stream.find('form.edit');

                    that.updateSidebarHeight();
                    that.initStreamEditForm();

                    that.unbindScroll();
                    that.unlock();
                },

                error: function() {
                    that.loadedStreamId = null;
                    that.unlock();
                }
            });
        }
    }

    removeStream() {
        var that = this;

        if(this.locked) return;
        this.lock();

        if(!window.confirm(this.texts.removeStream)) {
            that.unlock();
            return;
        }

        new DataLoader({
            url: '/yard/remove/' + that.loadedStreamId + '/',

            success: function(data) {
                that.menuStreamButtons.filter('[data-id="' + that.loadedStreamId + '"]').remove();
                that.refreshStreamMenuButtons();

                that.unlock();
                that.loadStream('first');
            },

            error: function() {
                that.unlock();
            }
        });
    }
}

export { Yard }
